module.exports = "<a #link href=\"javascript:void(0)\"\n  class=\"g-admin-link g-admin-link-icon\">\n  <ng-content></ng-content>\n</a>"